import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-pdf-to-word',
    imports: [],
    templateUrl: './blog-pdf-to-word.component.html',
    styleUrl: './blog-pdf-to-word.component.css'
})
export class BlogPdfToWordComponent {

}
